import React from 'react';
import PropTypes from 'prop-types';
import { TextField, styled, ButtonGroup, Button } from '@mui/material';
import classnames from 'classnames';

export const StyledButton = styled(Button)(({ theme }) => ({
  textTransform: 'inherit',
  width: '36px',
  fontSize: '35px',
  height: '36px',
  fontWeight: 200,

  '&.Mui-disabled': {
    opacity: 0.4,
    cursor: 'not-allowed',
    color: theme.palette.common.white,
    backgroundColor: '#F6F6F6'
  },

  '&.MuiButton-outlinedSecondary': {
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.secondary.main}`,
    padding: '7px 12px',
    color: theme.palette.text.primary,

    '&:hover': {
      background: theme.palette.secondary.main,
      border: `1px solid ${theme.palette.secondary.main}`,
    },

    '&.Mui-disabled': {
      backgroundColor: theme.palette.grey[600]
    }
  }
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& > div': {
    position: 'relative',
    fontSize: '1.125rem',
    lineHeight: '24px',
    fontWeight: 'normal',
    backgroundColor: theme.palette.common.white,
    height: '36px',
    overflow: 'hidden',
    width: '65px',
    borderRadius: 0,
    border: `1px solid ${theme.palette.secondary.main}`,

    'input:-webkit-autofill': {
      boxShadow: 'inset 0 0 0 1000px #fff'
    },

    '&.Mui-disabled': {
      background: theme.palette.action.disabledBackground,
      backgroundColor: '#F6F6F6',

      '& > input': {
        '-webkit-text-fill-color': theme.palette.grey[1000]
      }
    },

    '& > input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '& >input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },

    '& > fieldset': {
      border: `0.5px solid ${theme.palette.action.disabledBackground}`
    },

    '&:hover': {
      '& > fieldset.MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.secondary.main
      }
    },

    '&.Mui-focused': {
      '& > fieldset.MuiOutlinedInput-notchedOutline': {
        borderWidth: '0.5px',
        borderColor: theme.palette.secondary.main
      }
    },

    '&.MuiInputBase-sizeSmall': {
      height: 36,

      '& > input': {
        padding: '6px 12px',
        textAlign: 'center',
      }
    },

    '& > div.MuiInputAdornment-root': {
      '& + input': {
        paddingLeft: 0,
        textAlign: 'center',
      }
    },
  },
}));

export const CustomCounter = ({ value = '', className, required, disabled, touchedById, setFieldValue, name, isDecreaseDisabled = false, ...props }) => {
  return (
    <ButtonGroup variant="outlined" color="secondary" disabled={disabled}>
      <StyledButton
        sx={{ borderRadius: '12px 0 0 12px' }}
        onClick={() => {
          touchedById();
          setFieldValue(name, Number(value) - 1);
        }}
        disabled={Number(value) <= 1 || isDecreaseDisabled}
      >-</StyledButton>
      <StyledTextField
        {...props}
        className={classnames(className, required && 'required')}
        disabled={disabled}
        value={value}
        onChange={e => {
          const input = e.target.value;
          if (!input || /^[1-9]$/.test(input[0]))
            if (!input || /^[0-9]$/.test(input[input.length - 1])) {
              touchedById();
              setFieldValue(name, input);
            }
        }}
        sx={{ marginLeft: '-1px' }}
      />
      <StyledButton
        sx={{ borderRadius: '0 12px 12px 0' }}
        onClick={() => {
          touchedById();
          setFieldValue(name, Number(value) + 1);
        }}
      >+</StyledButton>
    </ButtonGroup>
  );
};

CustomCounter.propTypes = {
  value: PropTypes.any,
  className: PropTypes.object,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
  setFieldValue: PropTypes.func,
  touchedById: PropTypes.func,
  name: PropTypes.string,
  isDecreaseDisabled: PropTypes.bool
};

CustomCounter.defaultProps = {
  value: undefined,
  required: false
};
